import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import CoreuiVue from '@coreui/vue'

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'

import './assets/scss/app.scss'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { MdField, MdSnackbar, MdProgress } from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

import 'vue2-animate/dist/vue2-animate.css'

import Vuelidate from 'vuelidate'

import VueTheMask from 'vue-the-mask'

import Loading from 'vue-loading-overlay';

import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(MdField)
Vue.use(MdSnackbar)
Vue.use(MdProgress)

Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(CoreuiVue)

Vue.use(VueTheMask)
Vue.use(Loading);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
